import React, {useEffect, useImperativeHandle, useRef} from "react";
import {OrderedListOutlined, BorderOutlined, CheckSquareOutlined} from "@ant-design/icons";
import {Button, Form, Input, Modal, Table} from "antd";
import {useModel} from "../../../models";
import {EditableRow,EditableCell} from "../../../utils/EditTable"

const OPT_TYPE = {
    ADD: 1,
    REMOVE: 2
}

export default function () {
    const [form] = Form.useForm();
    const [
        {
            documentMaterialList,
            addMaterialModelVisible,
            materialList,
            materialPageInfo,
            selectedMaterialList,
        },
        {
            setAddMaterialModelVisible,
            loadStockData,
            transSelectedStockItemListToSoItemList,
            addSelectedMaterial,
            setSelectedMaterialList,
            removeSelectedMaterial,
            setMaterialList
        }
    ] = useModel("saleSo");
    const {pageSize,} = materialPageInfo;

    useEffect(() => {
        loadStockData({showMsg: false, data: {pageNum: 1, pageSize}});
    }, []);
    const onOk = async () => {
        //将已选库存配件添加到订单商品明细里
        transSelectedStockItemListToSoItemList();
        setSelectedMaterialList([]);
        //关闭窗口
        setAddMaterialModelVisible(false);
    }
    const onClose = () => {
        setAddMaterialModelVisible(false);
    }
    const onSearch = () => {
        // const {pageSize, } = materialPageInfo;
        loadStockData({
            showMsg: false,
            data: {
                pageSize,
                pageNum: 1,
                ...form.getFieldsValue()
            }
        });
    }

    const onAdd = (record) => {
        addSelectedMaterial(record);
    }
    const onRemove = (record) => {
        removeSelectedMaterial(record);
    }
    const Title = () => {
        return (

            <h3 style={{flex: "1"}}>
                <OrderedListOutlined/>
                <span className="margin-left-8">销售单-选择配件</span>
            </h3>

        )
    }
    const columns = (optType) => [
        {
            title: '',
            width: 40,
            render: (_, __, index) => index + 1,
        },
        {
            title: '商品编号',
            width: 140,
            dataIndex: 'materialCode',
            align: 'left',
        },
        {
            title: '商品名称',
            width: 280,
            dataIndex: 'materialName',
        },
        {
            title: '库存',
            width: 140,
            dataIndex: 'inventoryNum',
        },
        {
            title: '数量',
            width: 80,
            dataIndex: 'Num',
            editable: true,
        },
        {
            title: '单位',
            width: 80,
            dataIndex: 'materialUnitName',
        },
        {
            title: '商品品牌',
            width: 100,
            dataIndex: 'materialBrandName',
        },
        // {
        //     title: '分类代码',
        //     width: 140,
        //     dataIndex: 'groupCode',
        // },
        {
            title: '操作',
            width: 60,
            fixed: 'right',
            render: (text, record) => (
                optType === OPT_TYPE.ADD ? (<Button
                    type="link"
                    htmlType="button"
                    className="margin-left-8"
                    size="small"
                    disabled={
                        !!selectedMaterialList.find(el => el.id === record.id)
                        || !!documentMaterialList.find(el => el.materialId === record.materialId)
                    }
                    onClick={() => onAdd(record)}
                >
                    添加
                </Button>) : (<Button
                    type="link"
                    htmlType="button"
                    className="margin-left-8"
                    size="small"
                    onClick={() => onRemove(record)}
                >
                    移除
                </Button>)),
        },
    ];
    const StockSearchForm = () => {
        return (
            <Form form={form} name="stock_search_form" layout="inline" onFinish={onSearch}>
                <Form.Item
                    name="codeOrName"
                >
                    <Input
                        placeholder="请输入商品编号或商品名称"
                        style={{width: "150px"}}
                    />
                </Form.Item>
                <Form.Item shouldUpdate={true}>
                    <Button htmlType="submit" type="primary">查询</Button>
                </Form.Item>
            </Form>
        )
    }
    
    // const StockMaterialList = () => {
    //     return (
    //         <>
    //             <div style={{margin: "0 0 8px", display: "flex"}}>
    //                 <h3 style={{width: "700px", paddingTop: "6px"}}>
    //                     <BorderOutlined/> 待选配件列表
    //                 </h3>
    //                 <div className="detail-list-statistic" style={{textAlign: "right"}}>
    //                     <StockSearchForm/>
    //                 </div>
    //             </div>
    //             <Table
    //                 columns={columns(OPT_TYPE.ADD)}
    //                 dataSource={materialList}
    //                 bordered
    //                 pagination={{
    //                     // simple: true,
    //                     hideOnSinglePage: false,
    //                     showQuickJumper: true,
    //                     defaultCurrent: 1,
    //                     defaultPageSize: pageSize,
    //                     onChange: (pageNum, pageSize) => {
    //                         loadStockData({showMsg: false, data: {pageSize, pageNum, ...form.getFieldsValue()}});
    //                     },
    //                     total: materialPageInfo.total,
    //                     current: materialPageInfo.pageNum,
    //                 }}
    //                 scroll={{y: 220, x: 1300}}
    //             />
    //         </>
    //     )
    // }

    // const SelectedStockMaterialList = () => {
    //     return (
    //         <>
    //             <div style={{margin: "8px 0", display: "flex"}}>
    //                 <h3 style={{width: "700px", paddingTop: "6px"}}>
    //                     <CheckSquareOutlined/> 已选配件列表
    //                 </h3>
    //                 <div className="detail-list-statistic" style={{textAlign: "right"}}>

    //                 </div>
    //             </div>
    //             <Table
    //                 columns={columns(OPT_TYPE.REMOVE)}
    //                 dataSource={selectedMaterialList}
    //                 bordered
    //                 pagination={false}
    //                 scroll={{y: 220, x: 1300}}
    //             />
    //         </>
    //     )
    // }
    const components = {
        body: {
            row: EditableRow,
            cell: EditableCell,
        },
    };
    const handleSave = (row) => {
        setMaterialList(materialList.map(el => {
            if (el.key === row.key) {
                return row
            } else {
                return el
            }
        }))
    }
    const mapColumns = handleSave => (columns(OPT_TYPE.ADD).map(col => {
        if (!col.editable) {
            return col;
        }

        return {
            ...col,
            onCell: record => ({
                record,
                editable: col.editable,
                dataIndex: col.dataIndex,
                title: col.title,
                handleSave:handleSave,
                editList:materialList,
                column:columns()
            }),
        };
    }));

    const handleSave1 = (row) => {
        // console.log(row)
        // let newList = 
        // console.log(newList)
        setSelectedMaterialList(selectedMaterialList.map(el => {
            if (el.key === row.key) {
                return row
            } else {
                return el
            }
        }))
    }
    const mapColumns1 = handleSave1 => (columns(OPT_TYPE.REMOVE).map(col => {
        if (!col.editable) {
            return col;
        }

        return {
            ...col,
            onCell: record => ({
                record,
                editable: col.editable,
                dataIndex: col.dataIndex,
                title: col.title,
                handleSave:handleSave1,
                editList:selectedMaterialList,
                column:columns()
            }),
        };
    }));        
    return (
        <Modal
            title={<Title/>}
            width={1024}
            visible={addMaterialModelVisible}
            onOk={onOk}
            onCancel={onClose}
        >
            {/* <StockMaterialList/> */}
            <>
                <div style={{margin: "0 0 8px", display: "flex"}}>
                    <h3 style={{width: "700px", paddingTop: "6px"}}>
                        <BorderOutlined/> 待选配件列表
                    </h3>
                    <div className="detail-list-statistic" style={{textAlign: "right"}}>
                        <StockSearchForm/>
                    </div>
                </div>
                <Table
                    components={components}
                    columns={mapColumns(handleSave)}
                    dataSource={materialList}
                    bordered
                    pagination={{
                        // simple: true,
                        hideOnSinglePage: false,
                        showQuickJumper: true,
                        defaultCurrent: 1,
                        defaultPageSize: pageSize,
                        onChange: (pageNum, pageSize) => {
                            loadStockData({showMsg: false, data: {pageSize, pageNum, ...form.getFieldsValue()}});
                        },
                        total: materialPageInfo.total,
                        current: materialPageInfo.pageNum,
                    }}
                    scroll={{y: 220, x: 1300}}
                />
            </>            
            {/* <SelectedStockMaterialList/> */}
            <>
                <div style={{margin: "8px 0", display: "flex"}}>
                    <h3 style={{width: "700px", paddingTop: "6px"}}>
                        <CheckSquareOutlined/> 已选配件列表
                    </h3>
                    <div className="detail-list-statistic" style={{textAlign: "right"}}>

                    </div>
                </div>
                <Table
                    components={components}
                    columns={mapColumns1(handleSave1)}
                    dataSource={selectedMaterialList}
                    bordered
                    pagination={false}
                    scroll={{y: 220, x: 1300}}
                />
            </>            
        </Modal>
    );
}